import { SECTIONS } from "../../../../config/constants";
import PageHead from "../../../layout/PageHead";
import {
  Empty,
  Tabs,
  Select,
  Button,
  Breadcrumb,
  Form,
  Input,
  Divider,
  Checkbox,
  InputNumber,
  Menu,
} from "antd";
import "./Enrichment.css";
import { DiffOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import GroupCodesService from "../../../../services/groupcodes/GroupCodesService";
import TablesService from "../../../../services/tables/TablesService";
import { useTranslation } from "react-i18next";
import {ROUTES} from "../../../../config/consts/routes";

const { TabPane } = Tabs;

const routes = [
  {
    path: ROUTES.general.main.route,
    breadcrumbName: SECTIONS.general.name,
  },
  {
    breadcrumbName: SECTIONS.operation.name,
  },
  {
    path: ROUTES.operation.enrichment.route,
    breadcrumbName: ROUTES.operation.enrichment.name,
  },
];

const Enrichment = () => {
  const { t, i18n } = useTranslation("translations");

  const { Option } = Select;
  const { TextArea } = Input;

  const [selectedTable, setSelectedTable] = useState<any>(null);
  const [selectedField, setSelectedField] = useState<any>(null);

  const [groupCodes, setGroupCodes] = useState<any>([]);
  const [entities, setEntities] = useState<any>([]);
  const [operations, setOperations] = useState<any>([]);
  const [selectedGroupCode, setSelectedGroupCode] = useState<any>();
  const [selectedEntity, setSelectedEntity] = useState<any>();
  const [selectedOperation, setSelectedOperation] = useState<any>();

  useEffect(() => {
    document.title = ROUTES.operation.enrichment.name;
  }, []);

  useEffect(() => {
    GroupCodesService.getAll().then((response: any) => {
      const data = response.data;
      setGroupCodes(data);
    });
    TablesService.getAllEntities().then((response: any) => {
      const data = response.data;
      setEntities(data);
    });
    TablesService.getAllOperations().then((response: any) => {
      const data = response.data;
      setOperations(data);
    });
  }, []);

  const handleTableChange = (value: string) => {
    setSelectedTable(tableItems.find((x) => x.key === value));
  };
  function handleTableMenuClick(e: any) {
    setSelectedTable(tableItems.find((x) => x.key === e.key));
  }
  const handleFieldChange = (value: string) => {
    setSelectedField(fieldItems.find((x) => x.key === value));
  };
  function handleFieldMenuClick(e: any) {
    setSelectedField(fieldItems.find((x) => x.key === e.key));
  }

  function onAddTableClick(e: any) {
    setSelectedTable({ key: "-1" });
  }
  function onAddFieldClick(e: any) {
    setSelectedField({ key: "-1" });
  }

  const tableItems = [
    {
      label: "Material_MDS_Template",
      key: "1",
      database: "dp_admin",
      schema: "Legacy",
      description: "",
      removeDuplicates: false,
      isTemplate: true,
    },
    {
      label: "Bert_Extract_REPS",
      key: "2",
      database: "dp_admin",
      schema: "Legacy",
      description: "",
      removeDuplicates: false,
      isTemplate: false,
    },
    {
      label: "Bert_Extract_SAP",
      key: "3",
      database: "dp_admin",
      schema: "Legacy",
      description: "",
      removeDuplicates: false,
      isTemplate: false,
    },
    {
      label: "Extra_records_Bert",
      key: "4",
      database: "dp_admin",
      schema: "Legacy",
      description: "",
      removeDuplicates: false,
      isTemplate: false,
    },
    {
      label: "TestMaterialen",
      key: "5",
      database: "dp_admin",
      schema: "Material",
      description: "testtable",
      removeDuplicates: false,
      isTemplate: false,
    },
    {
      label: "reps_file",
      key: "6",
      database: "dp_admin",
      schema: "test",
      description: "test description",
      removeDuplicates: false,
      isTemplate: true,
    },
  ];

  const fieldItems = [
    {
      label: "GroupCode",
      key: "1",
      datatype: "nvarchar",
      maxLength: "500",
      isMandatory: true,
      description: "Test 1",
      deltaCollection: "1",
      lbl: "",
    },
    {
      label: "Code",
      key: "2",
      datatype: "nvarchar",
      maxLength: "500",
      isMandatory: true,
      description: "Test 2",
      deltaCollection: "2",
      lbl: "",
    },
    {
      label: "Material",
      key: "3",
      datatype: "nvarchar",
      maxLength: "500",
      isMandatory: true,
      description: "Test 3",
      deltaCollection: "3",
      lbl: "",
    },
    {
      label: "SourceData",
      key: "4",
      datatype: "nvarchar",
      maxLength: "500",
      isMandatory: true,
      description: "Test 4",
      deltaCollection: "4",
      lbl: "",
    },
    {
      label: "OldMaterial",
      key: "5",
      datatype: "nvarchar",
      maxLength: "500",
      isMandatory: true,
      description: "Test 5",
      deltaCollection: "5",
      lbl: "",
    },
    {
      label: "StandardWarehouseCode",
      key: "6",
      datatype: "nvarchar",
      maxLength: "500",
      isMandatory: true,
      description: "Test 6",
      deltaCollection: "6",
      lbl: "",
    },
  ];

  return (
    <div>
      <PageHead
        title={t("Page.Operation.Enrichment.Headers.Enrichment", {
          lngs: i18n.languages,
          defaultValue: "Enrichment",
        })}
        icon={<DiffOutlined />}
        routes={routes}
        groupCodes={groupCodes}
        entities={entities}
        operations={operations}
        selectedGroupCode={selectedGroupCode}
        selectedEntity={selectedEntity}
        selectedOperation={selectedOperation}
        setSelectedGroupCode={setSelectedGroupCode}
        setSelectedEntity={setSelectedEntity}
        setSelectedOperation={setSelectedOperation}
        setSelectGroupCodeDisabled={false}
        setSelectEntityDisabled={false}
        setSelectOperationDisabled={false}
        mainAction={[]}
        otherActions={[]}
        setActionsDisabled={true}
      />
      <div className="card-container"></div>
    </div>
  );
};

export default Enrichment;
